export default __webpack_public_path__ + "img/dd807d27600840c894e585747dbecd2f.mp4";